import React, { useState } from "react";
import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import DeleteRequest from "../components/DeleteRequest";

interface DataType {
  key: string;
  id: string | any;
  request_retry_date: string;
  user_id: string;
  request_id: string;
  to_provider: string;
  number: string;
  from_number: string;
  to_number: string;
  from_provider: string;
  action_name: string;
  approval: string;
  ack_code: string;
  ack_date_isral: string;
  process_status: string;
  currentOperator: string;
  created_date: string;
}

export const convertDateToIsrael = async (dateTime) => {
  const utcMoment = moment.utc(dateTime, "YYYY-MM-DDTHH:mm:ss");
  const israelMoment = utcMoment.tz("Asia/Jerusalem");
  const israelTime = israelMoment.tz("Asia/Jerusalem"); //.format('YYYY-MM-DDTHH:mm:ss')
  return israelTime;
};

const InquireListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getInquireList,
    savePayload,
    getInquireReportList,
  } = props;

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.id ?? index + 1,
    request_retry_date: item?.request_retry_date,
    user_id: item?.user_id,
    request_id: item?.request_id,
    to_provider: item?.to_provider,
    number: item?.number,
    from_number: item?.from_number,
    to_number: item?.to_number,
    from_provider: item?.from_provider,
    ack_code: item?.ack_code,
    ack_date_isral: item?.ack_date_isral,
    action_name: item?.action_name,
    approval: item?.approval,
    currentOperator: item?.currentOperator,
    created_date: item?.created_date,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: "Request ID",
      dataIndex: "request_id",
      key: "request_id",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.request_id || "").localeCompare(b.request_id || ""),
      render: (_, record) => {
        return record?.request_id ? record?.request_id : CONSTANT.NO_DATA_FOUND;
      },
      fixed: "left",
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a?.created_date || "").localeCompare(b?.created_date || ""),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Provider",
      children: [
        {
          title: "From",
          dataIndex: "from_provider",
          key: "from_provider",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.from_provider || "").localeCompare(b.from_provider || ""),
          render: (_, record) => {
            return record?.from_provider
              ? record?.from_provider
              : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: "To",
          dataIndex: "to_provider",
          key: "to_provider",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.to_provider || "").localeCompare(b.to_provider || ""),
          render: (_, record) => {
            return record?.to_provider
              ? record?.to_provider
              : CONSTANT.NO_DATA_FOUND;
          },
        },
        {
          title: "Current Operator",
          dataIndex: "currentOperator",
          key: "currentOperator",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) =>
            (a.currentOperator || "").localeCompare(b.currentOperator || ""),
          render: (_, record) => {
            return record?.currentOperator
              ? record?.currentOperator
              : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },

    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.number || "").localeCompare(b.number || ""),
      render: (_, record) => {
        return record?.number ? record?.number : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: "Action Name",
      dataIndex: "action_name",
      key: "action_name",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.action_name || "").localeCompare(b.action_name || ""),
      render: (_, record) => {
        return record?.action_name
          ? record?.action_name
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Approval",
      dataIndex: "approval",
      key: "approval",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.approval || "").localeCompare(b.approval || ""),
      render: (_, record) => {
        return record?.approval ? record?.approval : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "ACK CODE",
      dataIndex: "ack_code",
      key: "ack_code",
      width: 180,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.ack_code || "").localeCompare(b.ack_code || ""),
      render: (_, record) => {
        return record?.ack_code ? record?.ack_code : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "ACK CODE Date",
      dataIndex: "ack_date_isral",
      key: "ack_date_isral",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.ack_date_isral || "").localeCompare(b.ack_date_isral || ""),
      render: (_, record) =>
        record?.ack_date_isral
          ? record?.ack_date_isral //dayjs(record?.step1_ack_code_date).format(CONSTANT.POST_DATE_TIME_FORMAT)
          : CONSTANT.NOT_UPDATED,
    },

    {
      title: "Action",
      key: "action",
      width: 150,
      fixed: "right",
      render: (_, record, index) => (
        <Space size="middle" wrap>
          <Tooltip title={"Reload List"}>
            <Button
              onClick={() => {
                getInquireReportList(record?.request_id);
              }}
              icon={<ReloadOutlined />}
              type="default"
              className="EditBtn iconBtn"
              disabled={record?.process_status === "Complete" ? true : false}
            />
          </Tooltip>
          <Tooltip title={"Delete Request"}>
            <Button
              onClick={() => {
                handleDeleteRequest(record);
              }}
              icon={<DeleteOutlined />}
              type="default"
              className="cancelBtn iconBtn"
              disabled={record?.process_status === "Complete" ? true : false}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getInquireList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getInquireList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>

      <DeleteRequest
        title={openDeleteData?.request_id}
        close={handleDeleteRequest}
        open={openDeleteModal}
        deleteValues={openDeleteData}
        name={"Request ID"}
        getInquireList={getInquireList}
      />
    </>
  );
};
export default InquireListTable;
